import React from 'react';
import { Modal, Tabs } from 'antd';
import EditTourDetailsForm from '../Forms/EditTourDetailsForm.js';
import EditTourMealsForm from '../Forms/EditTourMealsForm.js';
import EditTourActivityFlagsForm from '../Forms/EditTourActivityFlagsForm.js';
import EditTourIndicatorsForm from '../Forms/EditTourIndicatorsForm.js';
import EditTourPayTransactionsForm from '../Forms/EditTourPayTransactionsForm.js';

const { TabPane } = Tabs;

const EditTourContainer = ({ state, user, ...props }) => {

  return(
    <Modal
      open={state.showItemContextModal}
      title={props.contextMenuSelection}
      onCancel={props.handleModalCancel}
      footer={[
      ]}
    >
     {
       (
          !state.loading &&
            <Tabs defaultActiveKey="1">
              <TabPane tab={<p>Tour details</p>} key="1">
                <EditTourDetailsForm
                  loading={state.loading}
                  resource={state.resource}
                  itemDetails={state.itemDetails}
                  user={user}
                  confirmDialogue={state.confirmDialogue}
                  handleTourDurationChange={props.handleTourDurationChange}
                  handleTourStartTimeChange={props.handleTourStartTimeChange}
                  handleTourEndTimeChange={props.handleTourEndTimeChange}
                  handleMealStartTimeChange={props.handleMealStartTimeChange}
                  handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                  updateTour={props.updateTour}
                  handleItemDelete={props.handleItemDelete}
                />
              </TabPane>
              <TabPane tab={<p>Pay Transaction</p>} key="2">
                <EditTourPayTransactionsForm
                  // state
                  loading={state.loading}
                  resource={state.resource}
                  itemDetails={state.itemDetails}
                  user={user}
                  confirmDialogue={state.confirmDialogue}
                  tourPayTransactionsTableDataSource={state.tourPayTransactionsTableDataSource}
                  tourPayTransactions={state.tourPayTransactions}
                  jobElementsByTour={state.jobElementsByTour}
                  tourPayTransaction={state.tourPayTransaction}
                  payTransactionsByTour={state.payTransactionsByTour}
                  // methods
                  updateState={props.updateState}
                  handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                  handleItemDelete={props.handleItemDelete}
                  getTourPayTransaction={props.getTourPayTransaction}
                  createTourPayTransaction={props.createTourPayTransaction}
                  updateTourPayTransaction={props.updateTourPayTransaction}
                />
              </TabPane>
              <TabPane tab={<p>Indicators</p>} key="3">
                <EditTourIndicatorsForm
                  // state
                  loading={state.loading}
                  resource={state.resource}
                  itemDetails={state.itemDetails}
                  user={user}
                  confirmDialogue={state.confirmDialogue}
                  tourIndicatorsTableDataSource={state.tourIndicatorsTableDataSource}
                  tourIndicators={state.tourIndicators}
                  jobElementsByTour={state.jobElementsByTour}
                  tourIndicator={state.tourIndicator}
                  indicatorsByTour={state.indicatorsByTour}
                  codesByIndicator={state.codesByIndicator}
                  // methods
                  updateState={props.updateState}
                  handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                  handleItemDelete={props.handleItemDelete}
                  getTourIndicator={props.getTourIndicator}
                  getCodesByIndicator={props.getCodesByIndicator}
                  createTourIndicator={props.createTourIndicator}
                  updateTourIndicator={props.updateTourIndicator}

                />
              </TabPane>
              <TabPane tab={<p>Meals</p>} key="4">
                <EditTourMealsForm
                  // state
                  loading={state.loading}
                  resource={state.resource}
                  itemDetails={state.itemDetails}
                  user={user}
                  confirmDialogue={state.confirmDialogue}
                  mealsTableDataSource={state.mealsTableDataSource}
                  tourMeals={state.tourMeals}
                  jobElementsByTour={state.jobElementsByTour}
                  meal={state.meal}
                  // methods
                  updateState={props.updateState}
                  getTourMeals={props.getTourMeals}
                  getTourJobElements={props.getTourJobElements}
                  handleItemStartTimeChange={props.handleItemStartTimeChange}
                  handleItemDurationChange={props.handleItemDurationChange}
                  generateItemDuration={props.generateItemDuration}
                  handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                  updateMeal={props.updateMeal}
                  handleItemDelete={props.handleItemDelete}
                  createMeal={props.createMeal}
                />
              </TabPane>
              <TabPane tab={<p>Flags</p>} key="5">
                <EditTourActivityFlagsForm
                  // state
                  loading={state.loading}
                  resource={state.resource}
                  itemDetails={state.itemDetails}
                  user={user}
                  confirmDialogue={state.confirmDialogue}
                  tourActivityFlagsTableDataSource={state.tourActivityFlagsTableDataSource}
                  tourActivityFlags={state.tourActivityFlags}
                  jobElementsByTour={state.jobElementsByTour}
                  tourActivityFlag={state.tourActivityFlag}
                  activityFlagByTour={state.activityFlagByTour}
                  // methods
                  updateState={props.updateState}
                  handleItemStartTimeChange={props.handleItemStartTimeChange}
                  handleItemDurationChange={props.handleItemDurationChange}
                  generateItemDuration={props.generateItemDuration}
                  handleOmnibusFieldChange={props.handleOmnibusFieldChange}
                  handleItemDelete={props.handleItemDelete}
                  getTourActivityFlag={props.getTourActivityFlag}
                  createTourActivityFlag={props.createTourActivityFlag}
                  updateTourActivityFlag={props.updateTourActivityFlag}
                />
              </TabPane>
          </Tabs>
       )
       ||
       'loading...'
    }

    </Modal>
  )

}

export default EditTourContainer;
